/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { components } from "react-select";

/**
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const ValueContainer: typeof components.ValueContainer = (props) => {
    return (
        <components.ValueContainer
            {...props}
            css={css`
                // Need to ensure that we show as much of the SingleValue component as possible.
                align-self: stretch;
                padding-left: 0;
            `}
        >
            {props.children}
        </components.ValueContainer>
    );
};
